<template>
    <div class="order_text_tip">
        <Tabs value="content" @on-click="tapClicked">
            <TabPane label="贷款订单文字设置" name="content"></TabPane>
            <TabPane label="订单短信内容设置" name="sms"></TabPane>
            <TabPane label="提现内容弹框设置" name="alert"></TabPane>
        </Tabs>
        <Form :label-width="100">
            <FormItem :label="item.id.toString()" v-for="item in formItem" :key="item.id">
                <Input v-model="item.ch_memo" style="width:100px"></Input>
                <Input v-model="item.status" style="width:100px"></Input>
                <Input v-model="item[activeTab]"  style="width:300px"></Input>
                <Checkbox v-model="item.is_show_b">是否显示</Checkbox>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="doPost">提交</Button>
                <Button style="margin-left: 8px">取消</Button>
            </FormItem>
        </Form>
    </div>
</template>



<script>

export default {
    
    data() {
        return {
            activeTab: 'content',
            formItem: []
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        tapClicked(arg) {
            this.activeTab = arg;
        },
        doPost() {
            this.$post(this.$path.order_text_tip, {
                datas: this.formItem.map(item => {
                    //debugger
                    item.is_show = item.is_show_b ? 1 : 0;
                    return item;
                })
            }).then(res => {
                if (res.success) {
                    this.$Message.info('修改成功');
                } else {
                    this.$Message.error('修改失败');
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.order_text_tip, {
                
            }).then(res => {
                if (res.data) {
                    this.formItem = res.data.map(item => {
                        item.is_show_b = item.is_show == 1;
                        return item;
                    });
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        }
    }
    
};
</script>



<style lang="scss" scoped>
.ivu-form-item-content{
    margin-left: 0px!important;
    display: flex;
    flex-direction: row;
}
.ivu-input-wrapper{
    margin-right: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/order_text_tip/order_text_tip.vue